<template>
  <div class="content">
    <h3 is="sui-header">Welcome to Locàite Web Platform</h3>
    <div>
      We currently have mobile applications for both Apple IOS and Google Android platforms. Click on the following badges to download the applications.
    </div>
    <div class="badges">
      <a href="https://apps.apple.com/gb/app/loc%C3%A0ite/id1479473645"><img src="assets/app-store-badge-white.svg" class="badge apple"></a>
      <a href="https://play.google.com/store/apps/details?id=io.caite.locaite.app&gl=GB"><img src="assets/google-play-badge.png" class="badge google"></a>
    </div>
    <div class="mobile only" style="padding-top: 10pt">
      To set up billing away from the app, follow <a href="/billing">this link</a>.
    </div>
  </div>
</template>
<script>
  export default {
    components: {}
  }
</script>

<style scoped lang="less">
  .content {
    padding: 10pt;
  }
  .badges {
    .badge {
      vertical-align: middle;
      max-height: 45pt;
    }
  }


</style>
